module.exports = __webpack_public_path__ + "static/media/info.5d04c538.svg";